function normalizedText(value) {
    return String(value || "")
        .trim()
        .toLocaleLowerCase("it-IT");
}

function customerArticleCodes(item) {
    return Array.isArray(item && item.codici_cliente)
        ? item.codici_cliente.filter((code) => String(code || "").trim())
        : [];
}

export function matchesCustomerReturnArticle(item, queryText) {
    const query = normalizedText(queryText);
    if (!query) return true;

    return [item && item.codice, item && item.descrizione, ...customerArticleCodes(item)].some(
        (value) => normalizedText(value).includes(query)
    );
}

export function customerReturnArticleLabel(item, formatQuantity) {
    const customerCodes = customerArticleCodes(item);
    const parts = [`${item.codice} - ${item.descrizione}`];
    if (customerCodes.length) {
        parts.push(`codice cliente: ${customerCodes.join(", ")}`);
    }
    parts.push(`consegnati: ${formatQuantity(item.quantita_consegnata)}`);
    return parts.join(" — ");
}
